import { render, staticRenderFns } from "./DetectLayout.vue?vue&type=template&id=6fc9484a&scoped=true&"
import script from "./DetectLayout.vue?vue&type=script&lang=js&"
export * from "./DetectLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetectLayout.vue?vue&type=style&index=0&id=6fc9484a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9484a",
  null
  
)

export default component.exports